import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';

export default class BackOfANapkinTemplatesPersonWeeksRoleIndexComponent extends Component {
  @service organisation;
  @service store;
  @service intl;

  @tracked teamFormIsVisible = false;
  @tracked roleFormIsVisible = false;

  get ppw() {
    return this.organisation.ppw;
  }

  calculateValue(weeks = 0, people = 0) {
    return (+weeks || 0) * (+people || 0) * this.ppw;
  }

  get valueBeforeConfidence() {
    return this.calculateValue(
      this.args.calculation.weeks,
      this.args.calculation.people,
    );
  }

  @action
  role(role_id) {
    const role = this.store.peekRecord('role', role_id);
    return role;
  }

  @action
  teamName(team_id) {
    const team = this.store.peekRecord('team', team_id);
    return team?.name;
  }

  @action
  handleChange(e) {
    const calculation = { ...this.args.calculation };
    calculation[e.target.name] = Number(e.target.value);
    calculation.value = this.calculateValue(
      calculation.weeks,
      calculation.people,
    );
    calculation.price_person_week = this.ppw;
    this.args.onValueEmit(calculation);
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  @action
  onRender() {
    this.updateValue();
  }

  updateValue() {
    const finalValue = this.finalValue;
    if (isNaN(finalValue)) return;
    const calculation = { ...this.args.calculation };
    calculation.value = this.valueBeforeConfidence;
    this.args.onValueEmit(calculation);
  }

  @action
  setRole(e) {
    const calculation = { ...this.args.calculation };
    calculation.role_id = e.value;
    const teams = this.role(e.value).teamsThatPeopleOfThisRoleAreIn;
    if (teams?.length === 1) calculation.team_id = teams[0].id;
    this.args.onValueEmit(calculation);
  }

  @action
  runAutoTeamUpdate(role) {
    const teams = role.teamsThatPeopleOfThisRoleAreIn;
    if (teams?.length === 1) this.setTeam({ id: teams[0].id });
  }

  @action
  setTeam(e) {
    const calculation = { ...this.args.calculation };
    calculation.team_id = e.id;
    this.args.onValueEmit(calculation);
  }

  @action
  unsetRole() {
    const calculation = { ...this.args.calculation };
    calculation.role_id = null;
    this.args.onValueEmit(calculation);
  }

  @action
  unsetTeam() {
    const calculation = { ...this.args.calculation };
    calculation.team_id = null;
    this.args.onValueEmit(calculation);
  }

  get confidenceLabel() {
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      !isNullOrUndefined(this.args.calculation.confidence_value) &&
      !isNullOrUndefined(this.args.calculation.weeks) &&
      !isNullOrUndefined(this.args.calculation.people)
    )
      return (
        this.valueBeforeConfidence * this.args.calculation.confidence_value
      );
    else return '-';
  }

  @action
  toggleTeamForm(val) {
    if (val !== undefined) this.teamFormIsVisible = val;
    else this.teamFormIsVisible = !this.teamFormIsVisible;
  }

  @action
  toggleRoleForm(val) {
    if (val !== undefined) this.roleFormIsVisible = val;
    else this.roleFormIsVisible = !this.roleFormIsVisible;
  }

  @action
  onTeamAdded(team) {
    this.setTeam(team);
  }

  @action
  onRoleAdded(role) {
    this.setRole({ ...role, value: role.id });
  }

  get isDisabled() {
    return !this.args.editMode;
  }
}
